import {
	type PricelistSalesChannelUpsertInput,
	usePricelistSalesChannelUpsertMutation,
} from "@/generated/graphql";

export const usePricelistSalesChannelUpsert = () => {
	const [, upsert] = usePricelistSalesChannelUpsertMutation();

	const upsertPricelistSalesChannel = (
		input: PricelistSalesChannelUpsertInput,
	) => {
		return upsert({ input });
	};

	return {
		upsertPricelistSalesChannel,
	};
};
